import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGlobals, useTimeMonitorContext, useUserContext } from '@/hooks';

const ProtectedRoute = ({ element, requiredAccess }: any) => {
  const { isSignedIn } = useUserContext();
  const location = useLocation();
  const { validateLoginDate } = useTimeMonitorContext();
  const { canAccessCheckout, canAccessSuccess, setCanAccessCheckout } = useGlobals();

  useEffect(() => {
    if (requiredAccess !== 'checkout' && canAccessCheckout) {
      setCanAccessCheckout(false);
    }
  }, [requiredAccess, canAccessCheckout, setCanAccessCheckout]);

  useEffect(() => {
    validateLoginDate();
  }, [location.pathname]);

  useEffect(() => {
    document.addEventListener('visibilitychange', validateLoginDate);
    return () => document.removeEventListener('visibilitychange', validateLoginDate);
  }, []);

  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }

  if (requiredAccess === 'checkout' && !canAccessCheckout) {
    return <Navigate to="/carrinho" replace />;
  }

  if (requiredAccess === 'success' && !canAccessSuccess) {
    return <Navigate to="/checkout" replace />;
  }

  return element;
};

export default ProtectedRoute;
